import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, Divider, Grid, Link, svgIconClasses, TextField, Toolbar } from "@mui/material";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import SettingsIcon from "@mui/icons-material/Settings";
import { useDispatch, useSelector } from "react-redux";
import { fetchCarryScore, updateCarryScore } from "../../actions/carryScore";
import { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { makeStyles } from "@mui/styles";
import { ReactComponent as BtnX } from "../../assets/images/plus-circle-fill.svg";
import { updatePlanning } from "../../actions/planning";
import planningService from "../../services/planning.service";


const emails = ['username@gmail.com', 'user02@gmail.com'];
function ManageCarryScore(props) {
    const { t } = useTranslation()
    const { onClose, selectedValue, open, rubricCat, globalComponentData, scoreData, addAccumulate, accumulateUse } = props;
    const handleClose = () => {
        onClose(selectedValue);
    };
    const dispatch = useDispatch();
    const [totalScoreUsage, setTotalScoreUsage] = React.useState(0);
    const [checkEdit, setcheckEdit] = React.useState(false);
    const CarryScore = useSelector((state) => state.CarryScore);
    const Planning = useSelector((state) => state.Planning);
    const [score, setScore] = React.useState(0);

    useEffect(() => {
        dispatch(fetchCarryScore())
    }, []);
    useEffect(() => {
        setScore(accumulateUse)
    }, [accumulateUse, props.accumulateUse]);
    // const aFilteredCarryScore = CarryScore.filter((loRow) => rubricCat === loRow.rubricType);
    const onAddPress = () => {
        addAccumulate(score);
    }

    const check = (e) => {
        if (e.target.value !== "") {
            setcheckEdit(true)
        }
    }

    const scoreUsageChange = (evt, fields) => {
        // let oTemp = scoreData;
        // const oDataSet = evt.target.dataset
        let vValue = evt.target.value.replaceAll(/[^0-9.]/g, '');
        if (vValue.indexOf(".") === 0 || vValue.lastIndexOf(".") !== vValue.indexOf(".")) {
        } else if (vValue.indexOf("0") === 0 && vValue.indexOf("0") + 1 === vValue.lastIndexOf("0")) {
        } else if (vValue === "") {
            setScore(vValue)
            setTotalScoreUsage(vValue)
        } else {
            setScore(vValue)
            setTotalScoreUsage(vValue)
        }
        // calTotalCarryScore()
    }
    const calTotalCarryScore = () => {
        let oTemp = scoreData;
        let vTotalCarryScore = 0;
        vTotalCarryScore = vTotalCarryScore + oTemp.accumulate_use;
        setTotalScoreUsage(vTotalCarryScore)
    }
    const useStyles = makeStyles({
        "th-underline": {
            "border-bottom": "2px solid #A0A0A0 !important",
            // "border": "1px solid #A0A0A0 !important",
            "color": "#A0A0A0 !important"
        },
        "td-underline": {
            "border-bottom": "1px solid #E5E5E5 !important",
            // "border": "1px solid #A0A0A0 !important",
            "color": "#404349 !important"
        },
        CardHeader: {
            '& div > span': {
                fontSize: "14px !important",
                lineHeight: "20.93px !important",
                fontWeight: "400"
            }
        },
        input: {
            '& div > input': {
                color: "#5DA196",
                textAlign: "center",
                height: '8px'
            }
        },
        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        btnDisabled: {
            '& .Mui-disabled': {
                color: "#FFFFFF !important",
                backgroundColor: "#BABABA !important"
            }
        },
    });
    const classes = useStyles();
    return (
        <>
            <Grid item lg={12} md={12} m={0} p={3}>
                <Grid item container>
                    <Typography variant="h3" pb={2} fontSize={24} lineHeight="26.4px" fontWeight={500}>
                        {t('planning.label.manageCarryScore')}
                    </Typography>
                    <Box sx={{ flex: 1 }} />
                    <Box sx={{ position: "absolute", right: 0, margin: "18px 18px 0  0", top: 0, cursor: "pointer" }} onClick={handleClose}><BtnX /></Box>
                </Grid>
                <Divider />
                {/* {aFilteredCarryScore.length > 0 ?
                    aFilteredCarryScore.map((row, rowIndex) => ( */}
                <>
                    <Grid container item>
                        <Grid container>
                            <Grid item lg={12}>
                                <Typography fontSize={24} lineHeight="26.4px" fontWeight={500} variant="h3" pt={2} pb={2}> {rubricCat?.description}</Typography>
                                <Typography fontSize={18} lineHeight="19.8px" fontWeight={400} variant="h3" pb={3}> {scoreData?.rb_pa?.nameTh} </Typography>
                            </Grid>
                            <Grid container spacing={4}>
                                <Grid item xs={12} display="flex">
                                    <Grid item xs={6} textAlign="center" sx={{ paddingRight: "30px" }}>
                                        <Card sx={{ height: 1 }}>
                                            <CardHeader variant="header_carryscore"
                                                classes={{ root: classes.CardHeader }}
                                                title="คะแนนสูงสุดที่ใช้ได้ (Maximum)"
                                            />
                                            <CardContent>
                                                <Grid item display="flex" alignItems="baseline" textAlign="right" justifyContent="center">
                                                    <Typography fontSize={36} lineHeight="53.82px" fontWeight={300} color="#939393" variant="number_heading">{Number(scoreData?.max_accumulate)?.toFixed(2)}</Typography>
                                                    <Typography fontSize={24} lineHeight="35.88px" fontWeight={400} color="#939393" variant="number_heading" pl={1}>{t('label.score')}</Typography>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    <Grid item xs={6} textAlign="center">
                                        <Card sx={{ height: 1 }}>
                                            <CardHeader variant="header_use_carryscore"
                                                title="สรุปคะแนนที่ต้องการใช้งาน"
                                                classes={{ root: classes.CardHeader }}
                                            />
                                            <CardContent>
                                                <Grid item display="flex" alignItems="baseline" textAlign="right" justifyContent="center">
                                                    <Box display="flex" flexDirection="column" justifyContent="center">
                                                        <Box display="flex" flexDirection="row" alignItems="baseline" justifyContent="center">
                                                            <Typography fontSize={30} lineHeight="44.85px" fontWeight={400} color={score > Number(scoreData?.max_accumulate) || score > Number(scoreData?.accumulate_total) ? "#CC6058" : "primary"} variant="number_heading">{Number(score).toFixed(2)}</Typography>
                                                            <Typography fontSize={24} lineHeight="35.88px" fontWeight={500} color={score > Number(scoreData?.max_accumulate) || score > Number(scoreData?.accumulate_total) ? "#CC6058" : "primary"} variant="number_heading" pl={1}>{t('label.score')}</Typography>
                                                        </Box>
                                                        {score > Number(scoreData?.accumulate_total) ?
                                                            <Box display="flex" >
                                                                <Typography fontSize={10} lineHeight="14.95px" fontWeight={400} color={"#CC6058"} variant="label">คะแนนที่กรอกสูงกว่าคะแนนสะสมที่มี</Typography>
                                                            </Box>
                                                            : null
                                                        }
                                                    </Box>
                                                    <Typography fontSize={36} lineHeight="53.82px" fontWeight={400} color="#404349" variant="number_heading" pr={2} pl={2}>/</Typography>
                                                    <Typography fontSize={36} lineHeight="53.82px" fontWeight={400} color="#404349" variant="number_heading">{Number(scoreData?.accumulate_total)?.toFixed(2)}</Typography>
                                                    <Typography fontSize={24} lineHeight="35.88px" fontWeight={500} color="#404349" variant="number_heading" pl={1}>{t('label.score')}</Typography>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/*<Typography> {t('planning.label.inputRemainScore')} </Typography>*/}
                    <Typography fontSize={18} lineHeight="19.8px" fontWeight={500} color="#939393" pt={4} pb={4} variant="h5"> รายละเอียดคะแนนสะสม </Typography>
                    <Box p={4} sx={{ "background-color": "#FAFAFA" }}>
                        <TableContainer>
                            <Table aria-label="simple table" sx={{ "background-color": "#FAFAFA" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className={classes["th-underline"]}>{t('label.detail')}</TableCell>
                                        <TableCell align="center" className={classes["th-underline"]}>{t('label.expireDate')}</TableCell>
                                        <TableCell align="center" className={classes["th-underline"]}>{t('label.carryScore')}</TableCell>
                                        <TableCell align="center" className={classes["th-underline"]}>{t('label.usageScore')}</TableCell>
                                        <TableCell align="center" className={classes["th-underline"]}>{t('label.unit')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {/* {row.items.map((rowItem, rowItemIndex) => ( */}
                                    <TableRow>
                                        <TableCell component="th" scope="row"
                                            className={classes["td-underline"]}>
                                            {/* {rowItem.itemNameDesc} */} คะแนนยกยอด{rubricCat.description}
                                        </TableCell>
                                        <TableCell component="th" scope="row" sx={{ "text-align": "center" }}
                                            className={classes["td-underline"]}>
                                            {/* {rowItem.expireDate} */} -
                                        </TableCell>
                                        <TableCell component="th" scope="row" sx={{ "text-align": "center" }}
                                            className={classes["td-underline"]}>
                                            <Typography>{Number(scoreData?.accumulate_total)?.toFixed(2)}</Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row" sx={{ "text-align": "center" }}
                                            className={classes["td-underline"]}>
                                            <Formik
                                                enableReinitialize
                                                initialValues={{
                                                    usageScore: isNaN(parseInt(score)) ? 0 : score,
                                                }}
                                                validationSchema={Yup.object().shape({
                                                    // usageScore: Yup.string().url()
                                                    usageScore: Yup.number()
                                                        .integer()
                                                        .min(0)
                                                        .max(scoreData?.max_accumulate, "คะแนนที่กรอกสูงกว่าคะแนนสูงสุดที่ใช้ได้")
                                                })}
                                                onSubmit={() => {
                                                    // navigate('/app/dashboard', {replace: true});
                                                }}
                                            >
                                                {({
                                                    errors,
                                                    handleBlur,
                                                    handleChange,
                                                    handleSubmit,
                                                    isSubmitting,
                                                    touched,
                                                    values
                                                }) => (
                                                    <form onSubmit={handleSubmit}>
                                                        <TextField
                                                            sx={{ width: '60px' }}
                                                            value={score}
                                                            // inputProps={{
                                                            //     'data-rowIndex': rowIndex,
                                                            //     'data-rowItemIndex': rowItemIndex,
                                                            // }}
                                                            // error={Boolean(touched.usageScore && errors.usageScore)}
                                                            fullWidth
                                                            // helperText={touched.usageScore && errors.usageScore}
                                                            value={score}
                                                            margin="none"
                                                            name="usageScore"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                                scoreUsageChange(e)
                                                                check(e)
                                                            }}
                                                            type="text"
                                                            variant="outlined"
                                                            classes={score > Number(scoreData?.max_accumulate) || score > Number(scoreData?.accumulate_total) ? { root: classes.inputError } : { root: classes.input }}
                                                        />
                                                    </form>
                                                )}
                                            </Formik>
                                        </TableCell>
                                        <TableCell component="th" scope="row" sx={{ "text-align": "center" }}
                                            className={classes["td-underline"]}
                                        >
                                            คะแนน
                                        </TableCell>
                                    </TableRow>
                                    {/* ))} */}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Grid item container pt={3}>
                        <Box sx={{ flex: 1 }} />
                        {score > Number(scoreData?.accumulate_total) ?
                            <Typography fontSize={14} lineHeight="20.93px" fontWeight={400} variant="label" color="#CC6058">
                                คะแนนที่กรอกสูงกว่าคะแนนสะสมที่มี
                            </Typography>
                            : score > Number(scoreData?.max_accumulate) ?
                                <Typography fontSize={14} lineHeight="20.93px" fontWeight={400} variant="label" color="#CC6058">
                                    คะแนนที่กรอกสูงกว่าคะแนนสูงสุดที่ใช้ได้
                                </Typography>
                                : null
                        }
                    </Grid>
                    <Grid item container>
                        <Box sx={{ flex: 1 }} />
                        <Typography fontSize={14} lineHeight="20.93px" fontWeight={300} color="#A0A0A0" variant="label" p={1}>
                            คะแนนที่ถูกใช้ไป
                            <Typography fontSize={14} lineHeight="20.93px" fontWeight={400} variant="label" color={score > Number(scoreData?.max_accumulate) || score > Number(scoreData?.accumulate_total) ? "#CC6058" : "primary"} pl={4}>
                                {score !== undefined && score !== null && score !== "" ? Number(score).toFixed(2) : 0} {t('label.score')}
                            </Typography>
                        </Typography>
                    </Grid>
                    <Grid item container>
                        <Box sx={{ flex: 1 }} />
                        <Typography fontSize={14} lineHeight="20.93px" fontWeight={300} color="#A0A0A0" variant="label" p={1}>
                            คะแนนสะสมคงเหลือ
                            <Typography fontSize={14} lineHeight="20.93px" fontWeight={400} variant="label" pl={4} color={score > Number(scoreData?.accumulate_total) ? "#CC6058" : ""}>
                                {score !== undefined && score !== null && score !== "" ? (Number(scoreData?.accumulate_total) - score).toFixed(2) : 0} {t('label.score')}
                            </Typography>
                        </Typography>
                    </Grid>
                    {/* <Divider/> */}
                </>
                {/* )) */}
                {/* : <Box> not have</Box>} */}
                <Grid item container justifyContent="right" pt={4}>
                    <Grid item pr={4}>
                        <Button variant="dashed-solid" onClick={handleClose}>
                            {t('label.cancel')}
                        </Button>
                    </Grid>
                    <Grid item class={score !== undefined && score !== null && score !== "" && checkEdit === true ? score > Number(scoreData?.max_accumulate) ? `${classes.btnDisabled}` : null : `${classes.btnDisabled}`}>
                        <Button variant="contained" onClick={onAddPress} disabled={score !== undefined && score !== null && score !== "" && checkEdit === true ? score > Number(scoreData?.max_accumulate) || score > Number(scoreData?.accumulate_total) ? true : false : true}>
                            {t('label.save')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
function SimpleDialog(props) {
    const { onClose, selectedValue, open, rubricCat, globalComponentData, datas, addAccumulate, accumulateUse } = props;
    const handleClose = () => {
        onClose(selectedValue);
    };
    const handleListItemClick = (value) => {
        onClose(value);
    };
    const onAddPress = (value) => {
        addAccumulate(value);
    }
    return (
        <Dialog onBackdropClick={() => {return false}} onClose={handleClose} open={open} maxWidth='lg'>
            <ManageCarryScore onClose={handleClose} open={open} rubricCat={rubricCat} addAccumulate={onAddPress} accumulateUse={accumulateUse}
                globalComponentData={globalComponentData} scoreData={datas} />
        </Dialog>
    );
}
SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
export default function DialogManageCarryScore(props) {
    const { t } = useTranslation();
    const { rubricCat, isCarryScore, id, scoresTeaching, scoresReserach, addAccumulate, accumulateUse, openAcc, onClose } = props;
    const [open, setOpen] = React.useState(false);
    const [dataCarryScore, setDataCarryScore] = React.useState([]);
    const [selectedValue, setSelectedValue] = React.useState(emails[1]);
    const [globalComponentData, setGlobalComponentData] = React.useState({
        rubricCat: "",
        itemIndex: ""
    });
    useEffect(() => {
        getCarryScore()
    }, []);

    useEffect(() => {
        let check = openAcc !== null && openAcc !== null && openAcc !== "" ? openAcc : "****"
        if (check === rubricCat?.serial) {
            setOpen(true)
            getCarryScore()
        }
    }, [openAcc, props.openAcc]);
    const getCarryScore = () => {
        planningService.postCarryScore(id, scoresTeaching, scoresReserach).then(
            (response) => {
                setDataCarryScore({ ...response.data, accumulate_total: Number(response.data.accumulate_total).toFixed(2), max_accumulate: Number(response.data.max_accumulate).toFixed(2) })
            });
    }
    const handleClickOpen = () => {
        onClose()
        const oData = {
            rubricCat: rubricCat,
        }
        setGlobalComponentData(oData)
        setOpen(true);
        getCarryScore()
    };
    const handleClose = (value) => {
        onClose()
        setOpen(false);
        setSelectedValue(value);
    };
    const onAddPress = (value) => {
        onClose()
        addAccumulate(value, rubricCat.serial);
        setOpen(false);
    }
    return (
        <>
            <Button startIcon={<SettingsIcon />} sx={{ "display": isCarryScore === 'y' ? "flex" : "none" }}
                variant="toolbar" onClick={handleClickOpen}>{t('label.manageScore')}</Button>
            <SimpleDialog
                rubricCat={rubricCat}
                globalComponentData={globalComponentData}
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
                datas={dataCarryScore}
                addAccumulate={onAddPress}
                accumulateUse={accumulateUse}
            />
        </>
    );
}
